import request from '@/utils/request'

export function selectOtherFile(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/selectOtherFile?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}




export function getLargeCategory(data) {
    return request({
        url: `api/serviceCenter/otherFile/getLargeCategory`,
        method: 'post',
        data,
    })
}



export function getSubclass(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/getSubclass`,
        method: 'post',
        data,
    })
}

export function updateConfirmStatus(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/updateConfirmStatus?`,
        method: 'post',
        data,
    })
}

export function updateDownloadStatus(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/updateDownloadStatus?`,
        method: 'post',
        data,
    })
}

export function updateCollage(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/updateCollage?`,
        method: 'post',
        data,
    })
}

export function updateCollageUrgent(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/updateCollageUrgent?`,
        method: 'post',
        data,
    })
}
export function updateToArtificial(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/updateToArtificial?`,
        method: 'post',
        data,
    })
}

export function updateToSample(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/updateToSample?`,
        method: 'post',
        data,
    })
}
export function otherFileBatchDelete(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/otherFileBatchDelete?`,
        method: 'post',
        data,
    })
}

export function confirmConfirmStatus(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFile/confirmConfirmStatus?`,
        method: 'post',
        data,
    })
}


export function upDateOtherFile(data) {
    return request({
        url: `api/serviceCenter/otherFile/upDateOtherFile`,
        method: 'post',
        data,
    })
}

export function selectAllLargeCategory(data) {
    return request({
        url: `api/serviceCenter/otherFile/selectAllLargeCategory?access=${data}`,
        method: 'post',
    })
}
export function selectAllSubclass(data) {
    return request({
        url: `api/serviceCenter/otherFile/selectAllSubclass`,
        method: 'post',
        data,
    })
}